import { defineStore } from 'pinia'
import axios from 'axios'

export const useNavigationStore = defineStore({
   id: 'interactions-navigation',
   state: () => ({
      showingNavIDs: [],
   }),
   actions: {
      toggleNav(id) {
         const index = this.showingNavIDs.findIndex(navID => navID == id)
         if (index === -1) {
            // If the ID is not found in the array, add it
            this.showingNavIDs.push(id);
         } else {
            // If the ID is found, remove it from the array
            this.showingNavIDs.splice(index, 1);
         }
     },
      openNav(id) {
         const index = this.showingNavIDs.findIndex(navID => navID == id)
         if (index === -1) {
            // If the ID is not found in the array, add it
            this.showingNavIDs.push(id);
         }
     },
      closeNav(id) {
         const index = this.showingNavIDs.findIndex(navID => navID == id)
         if (index !== -1) {
            this.showingNavIDs.splice(index, 1);
         }
     }
   }
})